import { AnyAction } from 'redux';
import type { ReduxStore } from '~/contracts/vdp';
import initialState from '~/store/initialState';
import * as types from './actionTypes';

export default function ui(
  state: ReduxStore['ui'] = initialState.ui,
  action: AnyAction = { type: '' }
): ReduxStore['ui'] {
  const { type, payload } = action;

  switch (type) {
    case types.SET_SECTION_MOUNTED: {
      return {
        ...state,
        sectionMounted: {
          ...state.sectionMounted,
          [payload]: true
        }
      };
    }

    case types.SET_SECTION_VIEWED: {
      return {
        ...state,
        sectionViewed: {
          ...state.sectionViewed,
          [payload]: true
        }
      };
    }

    case types.SET_LAZY_LOAD: {
      return {
        ...state,
        isLazyLoadEnabled: payload
      };
    }

    case types.SET_LITE: {
      return {
        ...state,
        isLite: payload
      };
    }

    case types.SET_DISABLE_SPINNER: {
      return {
        ...state,
        isSpinnerDisabled: payload
      };
    }

    default:
      return state;
  }
}
